{
  "name": "Freight",
  "shadowR": 1288,
  "ambient": 7508378,
  "light": 9149341,
  "sky": 7710385,
  "fog": 7710385,
  "fogD": 374.8837427323032,
  "dthY": -10,
  "camPos": [316, 33, -156],
  "spawns": [[-15, 0, -356, 0, 1, 0], [232, 0, -392, 2, 2, 0], [394, 0, -201, 0, 2, 0], [292, 0, 164, 1, 2, 0], [86, 4, 116, 0, 0, 0], [-67, 0, -40, 0, 3, 0], [33, 0, -69, 0, 0, 0], [68, 0, -189, 0, 1, 0], [-87, 26, -73, 0, 0, 0]],
  "objects": [{
    "p": [-47, 24, -71],
    "s": [108, 2, 40],
    "c": 10197658
  }, {
    "p": [-18, 0, -88],
    "s": [42, 24, 4],
    "c": 9854020
  }, {
    "p": [-47, 56, -71],
    "s": [107, 3, 44],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [4, 27, -54],
    "s": [3, 29, 9],
    "c": 9854020
  }, {
    "p": [4, 27, -87],
    "s": [3, 31, 7],
    "c": 9854020
  }, {
    "p": [26, 0, -20],
    "s": [129, 24, 60],
    "c": 9854020
  }, {
    "p": [-47, 26, -85],
    "s": [108, 2, 13],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-47, 59, -71],
    "s": [108, 2, 45],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [4, 0, -70],
    "s": [3, 27, 40],
    "c": 9854020
  }, {
    "p": [-98, 26, -71],
    "s": [3, 31, 34],
    "c": 9854020
  }, {
    "p": [49, 49, -196],
    "s": [22, 6, 3],
    "c": 9854020
  }, {
    "p": [100, 0, -121],
    "s": [54, 46, 30],
    "c": 11172712,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [-101, 0, -18],
    "s": [4, 32, 577],
    "c": "#b5b5b5",
    "bo": 1
  }, {
    "p": [37, 20, -113],
    "s": [74, 3, 48],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [146, 20, -121],
    "s": [144, 3, 32],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [37, 0, -113],
    "s": [72, 63, 46],
    "c": 11172712,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [17, 0, -122],
    "s": [78, 23, 63],
    "c": 11172712,
    "e": 1447446
  }, {
    "p": [37, 62, -113],
    "s": [74, 3, 48],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [145, 46, -121],
    "s": [147, 3, 33],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [36, 4, -113],
    "s": [3, 60, 47],
    "c": 10197915
  }, {
    "p": [-74, 26, -57],
    "s": [10, 52, 10],
    "c": 9854020
  }, {
    "p": [-69, 26, -52],
    "s": [61, 33, 4],
    "c": 9854020
  }, {
    "p": [-18, 0, -52],
    "s": [41, 56, 4],
    "c": 9854020
  }, {
    "p": [0, 26, -89],
    "s": [5, 26, 3],
    "c": 9854020
  }, {
    "p": [-11, 26, -20],
    "s": [203, 25, 61],
    "c": 9854020,
    "bo": 1
  }, {
    "p": [-11, 24, -20],
    "s": [204, 2, 62],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [-41, -1, 6],
    "s": [6, 26, 9],
    "c": 10197658
  }, {
    "p": [81, 35, -5],
    "s": [8, 43, 43],
    "l": 1,
    "r": [-0.8, 0, 0],
    "c": 9854020
  }, {
    "p": [-107, 34, -5],
    "s": [8, 43, 43],
    "l": 1,
    "r": [-0.8, 0, 0],
    "c": 9854020
  }, {
    "p": [-44, 52, -89],
    "s": [93, 4, 3],
    "c": 9854020
  }, {
    "p": [-95, 26, -89],
    "s": [9, 30, 3],
    "c": 9854020
  }, {
    "p": [-21, 0, -120],
    "s": [3, 25, 63],
    "c": 10197658
  }, {
    "p": [-74, 77, -57],
    "s": [13, 2, 12],
    "c": 16119285
  }, {
    "p": [-2, 0, -251],
    "s": [185, 36, 113],
    "c": "#965c44",
    "bo": 1
  }, {
    "p": [-99, -1, -40],
    "s": [1, 25, 95],
    "c": "#9b9a9a"
  }, {
    "p": [-13, 0, -196],
    "s": [5, 55, 6],
    "c": 10197658
  }, {
    "p": [-96, 0, -197],
    "s": [6, 55, 8],
    "c": 10197658
  }, {
    "p": [-5, -2, -249],
    "s": [189, 3, 107],
    "c": 5853501,
    "t": 2
  }, {
    "p": [-97, 1, -251],
    "s": [4, 57, 100],
    "c": 9854020
  }, {
    "p": [99, 42, -299],
    "s": [4, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [154, -1, -189],
    "s": [3, 77, 3],
    "pe": 1,
    "t": 2
  }, {
    "p": [-14, 42, -196],
    "s": [151, 1, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-90, 36, -196],
    "s": [12, 20, 3],
    "c": 9854020
  }, {
    "p": [-13, 36, -196],
    "s": [26, 19, 3],
    "c": 9854020
  }, {
    "p": [76, 36, -306],
    "s": [32, 19, 3],
    "c": 9854020
  }, {
    "p": [11, 36, -196],
    "s": [1, 13, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [49, 36, -196],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-37, 36, -196],
    "s": [1, 13, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-74, 36, -196],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [146, 0, -161],
    "s": [20, 46, 50],
    "c": 11172712,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [-98, 0, -218],
    "s": [3, 30, 34],
    "c": 9854020
  }, {
    "p": [-55, 36, -196],
    "s": [14, 19, 3],
    "c": 9854020
  }, {
    "p": [30, 36, -196],
    "s": [16, 20, 3],
    "c": 9854020
  }, {
    "p": [-3, 55, -251],
    "s": [196, 3, 117],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [-3, 58, -251],
    "s": [197, 2, 118],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-50, 57, -243],
    "s": [30, 21, 15],
    "c": 9854020
  }, {
    "p": [-50, 74, -243],
    "s": [32, 2, 18],
    "c": 16119285
  }, {
    "p": [146, 46, -162],
    "s": [22, 3, 49],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [146, 20, -162],
    "s": [21, 3, 50],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [-1, 27, -251],
    "s": [189, 3, 115],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [-30, 57, -280],
    "s": [16, 16, 15],
    "c": 9854020
  }, {
    "p": [-54, 0, -196],
    "s": [5, 55, 6],
    "c": 10197658
  }, {
    "p": [30, 0, -196],
    "s": [5, 55, 6],
    "c": 10197658
  }, {
    "p": [220, -1, -108],
    "s": [3, 75, 3],
    "t": 2
  }, {
    "p": [151, -1, -351],
    "s": [3, 78, 3],
    "pe": 1,
    "t": 2
  }, {
    "p": [154, 69, -190],
    "s": [32, 2, 3],
    "t": 2
  }, {
    "p": [153, 61, -190],
    "s": [23, 2, 3],
    "t": 2
  }, {
    "p": [197, 63, -150],
    "s": [1, 1, 107],
    "l": 1,
    "r": [0, 0.7, 0],
    "c": 9539985,
    "t": 5
  }, {
    "p": [220, 61, -108],
    "s": [24, 2, 3],
    "t": 2
  }, {
    "p": [219, 68, -108],
    "s": [32, 2, 3],
    "t": 2
  }, {
    "p": [96, -1, -299],
    "s": [1, 46, 1],
    "pe": 1,
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [17, 0, -153],
    "s": [79, 25, 3],
    "c": "#9b9a9a"
  }, {
    "p": [422, 32, -230],
    "s": [402, 26, 11],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [421, -11, -383],
    "s": [449, 39, 5],
    "c": 7485215,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [227, 79, -303],
    "s": [5, 78, 34],
    "l": 1,
    "r": [2, 0, 0],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [421, 28, -296],
    "s": [451, 2, 182],
    "c": "#827e7d",
    "bo": 1
  }, {
    "p": [-44, 0, -328],
    "s": [4, 30, 50],
    "c": "#b5b5b5",
    "bo": 1
  }, {
    "p": [18, 23, -121],
    "s": [76, 2, 64],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [19, 25, -153],
    "s": [76, 2, 4],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [145, 0, -192],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [153, -1, -453],
    "s": [3, 78, 3],
    "r": [0, -0.35, 0],
    "t": 2
  }, {
    "p": [152, 69, -350],
    "s": [32, 2, 3],
    "t": 2
  }, {
    "p": [152, 61, -352],
    "s": [23, 2, 3],
    "t": 2
  }, {
    "p": [177, 63, -149],
    "s": [1, 1, 108],
    "l": 1,
    "r": [0, 0.7, 0],
    "c": 9539985,
    "t": 5
  }, {
    "p": [227, 77, -289],
    "s": [5, 78, 37],
    "l": 1,
    "r": [-2, 0, 0],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [229, 61, -296],
    "s": [11, 36, 11],
    "c": "#472213",
    "e": 1447446
  }, {
    "p": [271, 77, -296],
    "s": [7, 48, 6],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [421, 30, -296],
    "s": [452, 2, 183],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [422, 61, -296],
    "s": [404, 2, 145],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-21, 25, -123],
    "s": [4, 2, 64],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [162, 63, -321],
    "s": [1, 1, 262],
    "l": 1,
    "c": 9539985,
    "t": 5
  }, {
    "p": [145, 49, -121],
    "s": [148, 2, 34],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [137, 23, -121],
    "s": [162, 2, 32],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [37, 65, -113],
    "s": [75, 2, 49],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [146, 49, -162],
    "s": [23, 2, 50],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [146, 23, -162],
    "s": [21, 2, 50],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [429, 84, -296],
    "s": [320, 21, 52],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [271, 111, -299],
    "s": [3, 28, 15],
    "l": 1,
    "r": [2, 0, 0],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [271, 99, -319],
    "s": [3, 28, 15],
    "l": 1,
    "r": [1.13, 0, 0],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [92, 0, -196],
    "s": [5, 55, 6],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [119, 59, -195],
    "s": [50, 1, 1],
    "l": 1,
    "r": [0.03, -0.17, 0.18],
    "c": 9539985,
    "t": 5
  }, {
    "p": [318, 103, -280],
    "s": [7, 19, 7],
    "c": 9854020
  }, {
    "p": [411, 103, -280],
    "s": [7, 19, 7],
    "c": 9854020
  }, {
    "p": [514, 103, -280],
    "s": [7, 20, 7],
    "c": 9854020
  }, {
    "p": [318, 104, -314],
    "s": [7, 20, 7],
    "c": 9854020
  }, {
    "p": [410, 103, -314],
    "s": [7, 19, 7],
    "c": 9854020
  }, {
    "p": [512, 103, -314],
    "s": [7, 21, 7],
    "c": 9854020
  }, {
    "p": [335, -24, 18],
    "s": [1734, 4, 2577],
    "l": 1,
    "c": "#26414f",
    "e": "#1a4054",
    "o": 0.9,
    "t": 1,
    "ts": 0.8
  }, {
    "p": [361, -29, -160],
    "s": [74, 29, 96],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [446, -132, -32],
    "s": [240, 117, 58],
    "c": 8552061,
    "e": 1447446
  }, {
    "p": [447, -141, -296],
    "s": [398, 130, 180],
    "c": 8552061,
    "e": 1447446
  }, {
    "p": [-11, 49, -20],
    "s": [204, 3, 62],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [-11, 52, -20],
    "s": [205, 2, 63],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-11, 26, -20],
    "s": [205, 2, 63],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [274, -30, -395],
    "s": [6, 54, 62],
    "c": "#b5b5b5",
    "bo": 1
  }, {
    "p": [231, 63, 310],
    "s": [1, 1, 839],
    "l": 1,
    "c": 9539985,
    "t": 5
  }, {
    "p": [422, 58, -296],
    "s": [403, 3, 144],
    "c": "#827e7d"
  }, {
    "p": [276, -30, 102],
    "s": [9, 36, 97],
    "c": "#b5b5b5"
  }, {
    "p": [305, -29, 57],
    "s": [49, 35, 7],
    "c": "#b5b5b5"
  }, {
    "p": [126, 0, -427],
    "s": [291, 30, 4],
    "c": "#b5b5b5",
    "bo": 1
  }, {
    "p": [274, -31, -427],
    "s": [7, 66, 7],
    "c": "#ababab",
    "bo": 1
  }, {
    "p": [134, 0, -427],
    "s": [7, 35, 7],
    "c": "#ababab",
    "bo": 1
  }, {
    "p": [218, 0, -427],
    "s": [7, 35, 7],
    "c": "#ababab",
    "bo": 1
  }, {
    "p": [222, -2, 112],
    "s": [3, 75, 3],
    "pe": 1,
    "t": 2
  }, {
    "p": [196, 29, -23],
    "s": [115, 2, 109],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [196, 31, -23],
    "s": [115, 2, 109],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [97, -1, -200],
    "s": [3, 58, 3],
    "t": 2,
    "bo": 1
  }, {
    "p": [442, 49, -31],
    "s": [247, 2, 61],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [442, 51, -31],
    "s": [247, 2, 61],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [221, 61, 112],
    "s": [23, 2, 3],
    "t": 2
  }, {
    "p": [221, 68, 112],
    "s": [32, 2, 3],
    "t": 2
  }, {
    "p": [212, 63, 310],
    "s": [1, 1, 839],
    "l": 1,
    "c": 9539985,
    "t": 5
  }, {
    "p": [-416, -1, -546],
    "s": [118, 134, 335],
    "l": 1,
    "c": "#aa7b68"
  }, {
    "p": [-416, 132, -546],
    "s": [121, 4, 337],
    "l": 1,
    "c": 12632256,
    "e": 1447446
  }, {
    "p": [-416, 67, -546],
    "s": [121, 4, 337],
    "l": 1,
    "c": 12632256,
    "e": 1447446
  }, {
    "p": [-39, -1, -40],
    "s": [1, 25, 95],
    "c": "#9b9a9a"
  }, {
    "p": [145, 94, -580],
    "s": [219, 4, 137],
    "l": 1,
    "e": 1447446
  }, {
    "p": [145, 63, -580],
    "s": [219, 4, 137],
    "l": 1,
    "e": 1447446
  }, {
    "p": [-100, 0, -112],
    "s": [7, 34, 7],
    "c": "#ababab",
    "bo": 1
  }, {
    "p": [-100, 0, -156],
    "s": [7, 34, 7],
    "c": "#ababab",
    "bo": 1
  }, {
    "p": [-100, 0, 100],
    "s": [7, 34, 7]
  }, {
    "p": [-100, 0, 146],
    "s": [7, 34, 7]
  }, {
    "p": [-100, 0, 204],
    "s": [7, 34, 7]
  }, {
    "p": [-2, 30, -251],
    "s": [191, 2, 115],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [141, 2, 29],
    "s": [4, 57, 4],
    "c": 10197658
  }, {
    "p": [251, 4, 29],
    "s": [4, 55, 4],
    "c": 10197658
  }, {
    "p": [192, 6, -23],
    "s": [4, 53, 108],
    "c": 10197658
  }, {
    "p": [141, 3, -75],
    "s": [4, 57, 4],
    "c": 10197658
  }, {
    "p": [251, -1, -75],
    "s": [4, 61, 4],
    "c": "#9b9a9a"
  }, {
    "p": [141, -1, 29],
    "s": [5, 7, 5],
    "c": 10197658
  }, {
    "p": [251, 0, 29],
    "s": [5, 6, 5],
    "c": 10197658
  }, {
    "p": [192, 0, -23],
    "s": [5, 6, 109],
    "c": 10197658
  }, {
    "p": [251, -1, -75],
    "s": [5, 7, 5],
    "c": 10197658
  }, {
    "p": [141, -1, -75],
    "s": [5, 7, 5],
    "c": 10197658
  }, {
    "p": [563, -15, -32],
    "s": [4, 64, 57],
    "c": 10197658
  }, {
    "p": [26, 33, 129],
    "s": [253, 3, 117],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [92, 0, 85],
    "s": [119, 33, 28],
    "c": 11172712,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [-51, 0, 133],
    "s": [96, 33, 122],
    "c": 11172712,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [-3, 0, 70],
    "s": [5, 33, 7],
    "c": 10197658
  }, {
    "p": [31, 0, 69],
    "s": [5, 33, 5],
    "c": 10197658
  }, {
    "p": [14, 33, 67],
    "s": [39, 3, 7],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [-47, 4, 67],
    "s": [31, 1, 2],
    "c": "#453d2f",
    "t": 5
  }, {
    "p": [26, 0, 136],
    "s": [253, 4, 132],
    "c": "#9b9a9a"
  }, {
    "p": [-97, -1, 6],
    "s": [6, 26, 9],
    "c": 10197658
  }, {
    "p": [-96, -1, -86],
    "s": [6, 26, 9],
    "c": 10197658
  }, {
    "p": [-40, -1, -86],
    "s": [7, 26, 9],
    "c": 10197658
  }, {
    "p": [152, 61, -452],
    "s": [23, 2, 3],
    "r": [0, -0.09, 0],
    "t": 2
  }, {
    "p": [152, 69, -453],
    "s": [32, 2, 3],
    "r": [0, -0.09, 0],
    "t": 2
  }, {
    "p": [-244, -3, -227],
    "s": [34, 154, 39],
    "l": 1,
    "c": 11172712,
    "e": 1447446
  }, {
    "p": [26, 36, 129],
    "s": [253, 2, 117],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [14, 36, 67],
    "s": [40, 2, 8],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [475, -11, -282],
    "s": [341, 40, 151],
    "c": 7485215,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [237, -11, -240],
    "s": [81, 39, 66],
    "c": 7485215,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [422, 32, -362],
    "s": [402, 27, 11],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [224, 32, -296],
    "s": [2, 27, 122],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [274, 24, -404],
    "s": [6, 2, 39],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [325, 6, -84],
    "s": [9, 2, 57],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [92, 0, -306],
    "s": [5, 55, 6],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [402, 6, -160],
    "s": [9, 2, 95],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [326, 6, 28],
    "s": [7, 2, 65],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [297, 6, 57],
    "s": [51, 2, 7],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [276, 6, 105],
    "s": [9, 2, 91],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-101, 32, 131],
    "s": [4, 2, 241],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-101, 32, -179],
    "s": [5, 2, 255],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-44, 30, -324],
    "s": [4, 2, 41],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [185, 30, -427],
    "s": [181, 2, 5],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [26, 37, 129],
    "s": [251, 80, 115],
    "c": 11172712,
    "e": 1447446
  }, {
    "p": [-380, 93, 106],
    "s": [255, 4, 125],
    "l": 1,
    "c": "#bababa"
  }, {
    "p": [-380, 97, 106],
    "s": [254, 2, 125],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [149, 0, -121],
    "s": [44, 46, 30],
    "c": 11172712,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [-67, 0, -410],
    "s": [62, 31, 131],
    "c": "#965c44",
    "e": "#0e0e0e",
    "bo": 1
  }, {
    "p": [2, 12, -135],
    "s": [3, 50, 3],
    "c": 10197915
  }, {
    "p": [126, 6, -121],
    "s": [3, 42, 31],
    "c": 10197915
  }, {
    "p": [172, 5, -121],
    "s": [3, 43, 31],
    "c": 10197915
  }, {
    "p": [216, 5, -107],
    "s": [3, 41, 3],
    "c": 10197915
  }, {
    "p": [72, 5, -91],
    "s": [3, 57, 3],
    "c": 10197915
  }, {
    "p": [72, 0, -134],
    "s": [3, 62, 5],
    "c": 10197915
  }, {
    "p": [216, -2, -107],
    "s": [4, 8, 4],
    "c": 10197658
  }, {
    "p": [216, 3, -135],
    "s": [3, 45, 3],
    "c": 10197915
  }, {
    "p": [216, 0, -135],
    "s": [4, 6, 4],
    "c": 10197658
  }, {
    "p": [172, 0, -135],
    "s": [4, 6, 4],
    "c": 10197658
  }, {
    "p": [126, 0, -135],
    "s": [4, 6, 4],
    "c": 10197658
  }, {
    "p": [72, 0, -135],
    "s": [4, 6, 4],
    "c": 10197658
  }, {
    "p": [172, -2, -107],
    "s": [4, 8, 4],
    "c": 10197658
  }, {
    "p": [126, -2, -107],
    "s": [4, 8, 4],
    "c": 10197658
  }, {
    "p": [72, -1, -91],
    "s": [4, 7, 4],
    "c": 10197658
  }, {
    "p": [36, -1, -91],
    "s": [4, 7, 4],
    "c": 10197658
  }, {
    "p": [326, -30, 24],
    "s": [7, 36, 59],
    "c": "#b5b5b5"
  }, {
    "p": [325, -29, -84],
    "s": [9, 35, 57],
    "c": 8552061,
    "e": 1447446
  }, {
    "p": [-70, -2, -40],
    "s": [63, 1, 100],
    "c": 7039851,
    "t": 1
  }, {
    "p": [322, -1, -59],
    "s": [6, 50, 3],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [73, -26, -94],
    "s": [404, 26, 876],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [411, 24, -7],
    "s": [46, 16, 4],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [491, 24, -57],
    "s": [46, 16, 4],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [339, 24, -57],
    "s": [29, 16, 4],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [556, 24, -57],
    "s": [16, 16, 4],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [445, 32, -58],
    "s": [212, 1, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [458, 25, -58],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [444, 25, -58],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [377, 25, -58],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [364, 25, -58],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [524, 25, -58],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [539, 25, -58],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [531, 23, -32],
    "s": [36, 2, 56],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [300, -29, -138],
    "s": [50, 29, 383],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [368, 6, -108],
    "s": [77, 2, 9],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [620, 20, -296],
    "s": [6, 38, 121],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [368, -29, -108],
    "s": [77, 35, 9],
    "c": 8552061,
    "e": 1447446
  }, {
    "p": [402, -29, -160],
    "s": [9, 35, 95],
    "c": 8552061,
    "e": 1447446
  }, {
    "p": [443, 40, -57],
    "s": [237, 9, 4],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [-4, 26, -89],
    "s": [3, 10, 3],
    "c": 9854020
  }, {
    "p": [4, 54, -71],
    "s": [3, 2, 25],
    "c": 9854020
  }, {
    "p": [11, 49, -196],
    "s": [22, 6, 3],
    "c": 9854020
  }, {
    "p": [-37, 49, -196],
    "s": [22, 6, 3],
    "c": 9854020
  }, {
    "p": [-73, 49, -196],
    "s": [22, 6, 3],
    "c": 9854020
  }, {
    "p": [76, 36, -196],
    "s": [32, 19, 3],
    "c": 9854020
  }, {
    "p": [30, 0, -306],
    "s": [5, 55, 6],
    "c": 10197658
  }, {
    "p": [30, 36, -306],
    "s": [16, 20, 3],
    "c": 9854020
  }, {
    "p": [-13, 0, -305],
    "s": [5, 55, 6],
    "c": 10197658
  }, {
    "p": [-13, 36, -306],
    "s": [26, 19, 3],
    "c": 9854020
  }, {
    "p": [-54, 0, -305],
    "s": [5, 55, 6],
    "c": 10197658
  }, {
    "p": [-55, 36, -306],
    "s": [14, 19, 3],
    "c": 9854020
  }, {
    "p": [-90, 36, -306],
    "s": [12, 20, 3],
    "c": 9854020
  }, {
    "p": [-96, 0, -305],
    "s": [6, 55, 8],
    "c": 10197658
  }, {
    "p": [-37, 49, -306],
    "s": [22, 6, 3],
    "c": 9854020
  }, {
    "p": [-73, 49, -306],
    "s": [22, 6, 3],
    "c": 9854020
  }, {
    "p": [49, 49, -306],
    "s": [22, 6, 3],
    "c": 9854020
  }, {
    "p": [11, 49, -306],
    "s": [22, 6, 3],
    "c": 9854020
  }, {
    "p": [-14, 42, -306],
    "s": [151, 1, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [49, 36, -306],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [11, 36, -306],
    "s": [1, 13, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-37, 36, -306],
    "s": [1, 13, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-74, 36, -306],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [89, 36, -297],
    "s": [3, 19, 13],
    "c": "#965c44"
  }, {
    "p": [89, 36, -206],
    "s": [3, 19, 15],
    "c": 9854020
  }, {
    "p": [89, 36, -238],
    "s": [3, 19, 11],
    "c": 9854020
  }, {
    "p": [89, 36, -267],
    "s": [3, 19, 9],
    "c": 9854020
  }, {
    "p": [89, 49, -223],
    "s": [3, 6, 19],
    "c": 9854020
  }, {
    "p": [89, 49, -253],
    "s": [3, 6, 19],
    "c": 9854020
  }, {
    "p": [89, 49, -281],
    "s": [3, 6, 19],
    "c": 9854020
  }, {
    "p": [89, 42, -252],
    "s": [1, 1, 81],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [89, 36, -253],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [89, 36, -223],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [89, 36, -282],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [238, 0, -595],
    "s": [22, 237, 21],
    "l": 1,
    "c": 11172712,
    "e": 1447446
  }, {
    "p": [197, 0, -594],
    "s": [22, 237, 21],
    "l": 1,
    "c": 11172712,
    "e": 1447446
  }, {
    "p": [26, 72, 129],
    "s": [253, 3, 117],
    "c": "#9b9a9a"
  }, {
    "p": [26, 75, 129],
    "s": [253, 2, 117],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [26, 115, 129],
    "s": [253, 3, 117],
    "c": "#9b9a9a"
  }, {
    "p": [26, 118, 129],
    "s": [253, 2, 117],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [145, 12, -192],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [205, 0, -142],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [205, 12, -142],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [318, 0, -201],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [318, 0, -189],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [280, 12, -104],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [318, 12, -195],
    "s": [12, 2, 24],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [293, 0, -124],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [343, 0, -119],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [343, 12, -119],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [293, 7, -124],
    "s": [6, 2, 6],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [216, 0, 160],
    "s": [57, 26, 25],
    "i": 17
  }, {
    "p": [286, -1, -31],
    "s": [70, 90, 56],
    "c": "#965c44",
    "bo": 1
  }, {
    "p": [322, -1, -3],
    "s": [6, 50, 3],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [149, 0, -264],
    "s": [20, 21, 36],
    "c": 11172712,
    "e": 1447446
  }, {
    "p": [149, 21, -264],
    "s": [1, 4, 40],
    "c": "#9b9a9a"
  }, {
    "p": [155, 20, -264],
    "s": [12, 1, 37],
    "l": 1,
    "r": [0, 0, -0.2],
    "c": "#9b9a9a"
  }, {
    "p": [143, 20, -264],
    "s": [12, 1, 37],
    "l": 1,
    "r": [0, 0, 0.2],
    "c": "#9b9a9a"
  }, {
    "p": [133, 0, -255],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [133, 12, -255],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [195, 0, -121],
    "s": [44, 46, 30],
    "c": 11172712,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [56, 0, -144],
    "s": [2, 23, 4],
    "i": 3,
    "t": 2
  }, {
    "p": [155, 21, -264],
    "s": [13, 2, 38],
    "l": 1,
    "r": [0, 0, -0.2],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [143, 21, -264],
    "s": [13, 2, 38],
    "l": 1,
    "r": [0, 0, 0.2],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [83, 0, -189],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [83, 12, -189],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [280, 0, -128],
    "s": [20, 21, 36],
    "c": 11172712,
    "e": 1447446
  }, {
    "p": [280, 21, -128],
    "s": [1, 4, 40],
    "c": "#9b9a9a"
  }, {
    "p": [286, 20, -128],
    "s": [12, 1, 37],
    "l": 1,
    "r": [0, 0, -0.2],
    "c": "#9b9a9a"
  }, {
    "p": [274, 20, -128],
    "s": [12, 1, 37],
    "l": 1,
    "r": [0, 0, 0.2],
    "c": "#9b9a9a"
  }, {
    "p": [286, 21, -128],
    "s": [13, 2, 38],
    "l": 1,
    "r": [0, 0, -0.2],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [274, 21, -128],
    "s": [13, 2, 38],
    "l": 1,
    "r": [0, 0, 0.2],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [83, 24, -189],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [216, 25, 160],
    "s": [58, 2, 26],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [65, 23, -105],
    "s": [18, 2, 32],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [82, 0, -56],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [82, 12, -56],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-28, 0, -143],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-28, 12, -143],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [3, 26, -65],
    "s": [8, 2, 28],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-5, 26, -74],
    "s": [8, 2, 10],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [7, 0, -70],
    "s": [2, 26, 4],
    "i": 3,
    "t": 2
  }, {
    "p": [5, 0, -70],
    "s": [4, 24, 9],
    "v": 1,
    "c": "#ffffff",
    "t": 5,
    "ab": 1
  }, {
    "p": [-86, 34, -89],
    "s": [9, 2, 3],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-86, 26, -89],
    "s": [9, 8, 3],
    "c": 9854020
  }, {
    "p": [-4, 36, -89],
    "s": [3, 2, 3],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [280, 0, -104],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [286, 29, -31],
    "s": [70, 2, 58],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [286, 31, -31],
    "s": [70, 2, 58],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [286, 59, -31],
    "s": [71, 2, 58],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [286, 61, -31],
    "s": [71, 2, 58],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [286, 89, -31],
    "s": [71, 2, 58],
    "c": "#9b9a9a"
  }, {
    "p": [286, 91, -31],
    "s": [72, 2, 60],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [204, 0, 36],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [204, 12, 36],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-2, 36, -251],
    "s": [180, 13, 109],
    "c": "#475e72",
    "o": 0.7000000000000001,
    "t": 5
  }, {
    "p": [443, -16, -7],
    "s": [238, 40, 4],
    "c": 7485215,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [491, 24, -7],
    "s": [46, 16, 4],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [411, 24, -57],
    "s": [46, 16, 4],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [339, 24, -7],
    "s": [29, 16, 4],
    "c": 7485215,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [556, 24, -7],
    "s": [16, 16, 4],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [443, 40, -7],
    "s": [237, 9, 4],
    "c": 7485215,
    "e": 1447446
  }, {
    "p": [443, -16, -57],
    "s": [238, 40, 4],
    "c": 7485215,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [445, 32, -7],
    "s": [212, 1, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [377, 25, -7],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [364, 25, -7],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [444, 25, -7],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [458, 25, -7],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [524, 25, -7],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [539, 25, -7],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [451, 23, -32],
    "s": [36, 2, 56],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [371, 23, -32],
    "s": [36, 2, 56],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [450, 25, -32],
    "s": [197, 15, 46],
    "c": "#475e72",
    "o": 0.7000000000000001,
    "t": 5
  }, {
    "p": [99, 43, -299],
    "s": [5, 1, 3],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [157, 43, 76],
    "s": [4, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [154, -1, 76],
    "s": [1, 47, 1],
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [157, 44, 76],
    "s": [5, 1, 3],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [296, 41, -143],
    "s": [4, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [293, 1, -143],
    "s": [1, 43, 1],
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [296, 42, -143],
    "s": [5, 1, 3],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [200, -1, -390],
    "s": [1, 47, 1],
    "pe": 1,
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [-94, 43, -136],
    "s": [4, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [-97, -1, -136],
    "s": [1, 47, 1],
    "pe": 1,
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [-94, 44, -136],
    "s": [5, 1, 3],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [28, 43, 16],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [28, -1, 13],
    "s": [1, 47, 1],
    "pe": 1,
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [28, 44, 16],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [96, 42, -21],
    "s": [4, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [93, -1, -21],
    "s": [1, 46, 1],
    "pe": 1,
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [96, 43, -21],
    "s": [5, 1, 3],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [200, 43, -393],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [200, 42, -393],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [-13, 43, -189],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [-13, 44, -192],
    "s": [1, 1, 3],
    "c": "#727272",
    "t": 5
  }, {
    "p": [-13, 42, -189],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [172, 43, -101],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [172, 44, -104],
    "s": [1, 1, 3],
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [172, 42, -101],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [-97, -1, 42],
    "s": [1, 47, 1],
    "pe": 1,
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [-94, 44, 42],
    "s": [5, 1, 3],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [-94, 43, 42],
    "s": [4, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [18, 0, 16],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [18, 12, 16],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [191, 0, -363],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [191, 12, -363],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [248, 37, -23],
    "s": [9, 15, 107],
    "c": 9854020
  }, {
    "p": [196, 52, -23],
    "s": [113, 7, 107],
    "c": 9854020
  }, {
    "p": [192, 37, -23],
    "s": [22, 15, 107],
    "c": 9854020
  }, {
    "p": [144, 37, -70],
    "s": [9, 15, 13],
    "c": 9854020
  }, {
    "p": [144, 37, -22],
    "s": [9, 15, 11],
    "c": 9854020
  }, {
    "p": [144, 37, 24],
    "s": [9, 15, 13],
    "c": 9854020
  }, {
    "p": [196, 44, -75],
    "s": [98, 1, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [196, 44, 29],
    "s": [98, 1, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [159, 37, -75],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [171, 37, -75],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [216, 37, -75],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [230, 37, -75],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [230, 37, 29],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [216, 37, 29],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [171, 37, 29],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [159, 37, 29],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [141, 37, -6],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [141, 37, -52],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [141, 44, -22],
    "s": [1, 1, 82],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [194, 37, -23],
    "s": [105, 15, 103],
    "c": "#475e72",
    "o": 0.7000000000000001,
    "t": 5
  }, {
    "p": [141, 37, -40],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [141, 37, 6],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [92, 0, -347],
    "s": [6, 48, 7],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [-78, 0, -347],
    "s": [6, 48, 7],
    "c": "#9b9a9a"
  }, {
    "p": [7, 48, -410],
    "s": [176, 4, 133],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [7, 52, -410],
    "s": [177, 2, 134],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-45, 0, -33],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-95, 0, -2],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-93, 0, -45],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-68, 0, -189],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [-68, 12, -189],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-86, 49, -89],
    "s": [9, 3, 3],
    "c": 9854020
  }, {
    "p": [-4, 50, -89],
    "s": [3, 2, 3],
    "c": 9854020
  }, {
    "p": [26, 0, -311],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.61, 0],
    "c": "#d8f2ff"
  }, {
    "p": [154, -1, -194],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.61, 0],
    "c": "#d8f2ff"
  }, {
    "p": [134, -1, -265],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.78, 0],
    "c": "#d8f2ff"
  }, {
    "p": [154, -1, -285],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.78, 0],
    "c": "#d8f2ff"
  }, {
    "p": [192, -1, -372],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.78, 0],
    "c": "#d8f2ff"
  }, {
    "p": [150, -1, -343],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.31, 0],
    "c": "#d8f2ff"
  }, {
    "p": [95, -1, -301],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.57, 0],
    "c": "#d8f2ff"
  }, {
    "p": [160, -1, -139],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.7, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [195, -1, -139],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.7, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [203, -1, -203],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.7, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [215, -1, -141],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.87, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [267, -1, -138],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.87, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [309, -1, -203],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.87, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [195, -1, -204],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.13, -1.49, -3.13],
    "c": "#d8f2ff"
  }, {
    "p": [293, -1, -141],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.87, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [294, -1, -119],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.88, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [317, -1, -64],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.87, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [256, -1, -64],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.87, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [271, -1, -107],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.87, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [216, -1, -103],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#d8f2ff"
  }, {
    "p": [187, -1, -79],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.78, 0],
    "c": "#d8f2ff"
  }, {
    "p": [148, -1, -103],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.78, 0],
    "c": "#d8f2ff"
  }, {
    "p": [77, -1, -102],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.78, 0],
    "c": "#d8f2ff"
  }, {
    "p": [77, -1, -94],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.14, 0],
    "c": "#d8f2ff"
  }, {
    "p": [92, -1, -53],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.79, 0],
    "c": "#d8f2ff"
  }, {
    "p": [73, -1, -53],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.79, 0],
    "c": "#d8f2ff"
  }, {
    "p": [9, -1, -53],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.79, 0],
    "c": "#d8f2ff"
  }, {
    "p": [9, -1, -88],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.79, 3.14],
    "c": "#d8f2ff"
  }, {
    "p": [94, -1, -18],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.79, 0],
    "c": "#d8f2ff"
  }, {
    "p": [35, -1, 67],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.43, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [76, -1, 66],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.53, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [27, -1, 14],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.53, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [75, 0, 11],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [2.93, 1.56, -2.93],
    "c": "#d8f2ff"
  }, {
    "p": [156, -1, 76],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.43, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [219, -1, 110],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.43, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [203, -1, 108],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.09, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [196, -1, 25],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.26, 0],
    "c": "#d8f2ff"
  }, {
    "p": [138, -1, 17],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#d8f2ff"
  }, {
    "p": [137, -1, -68],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#d8f2ff"
  }, {
    "p": [134, 0, -22],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [134, 12, -22],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [136, -1, -29],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#d8f2ff"
  }, {
    "p": [129, -1, -15],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.09, 0],
    "c": "#d8f2ff"
  }, {
    "p": [129, -1, 68],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#d8f2ff"
  }, {
    "p": [-8, -1, 68],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#d8f2ff"
  }, {
    "p": [-96, -1, 66],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.61, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [-39, -1, 14],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#d8f2ff"
  }, {
    "p": [9, -1, 13],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#d8f2ff"
  }, {
    "p": [-95, -1, 41],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.44, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [-42, -1, -24],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#d8f2ff"
  }, {
    "p": [-95, -1, -35],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#d8f2ff"
  }, {
    "p": [-95, -1, -9],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.48, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [-44, -1, -78],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.23, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [-96, -1, -55],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [-26, -1, -153],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [-59, -1, -192],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0],
    "c": "#d8f2ff"
  }, {
    "p": [-95, -1, -137],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0],
    "c": "#d8f2ff"
  }, {
    "p": [74, -1, -190],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0],
    "c": "#d8f2ff"
  }, {
    "p": [60, -1, -139],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0],
    "c": "#d8f2ff"
  }, {
    "p": [136, -1, -189],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.88, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [139, -1, -245],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.44, 0],
    "c": "#d8f2ff"
  }, {
    "p": [94, -1, -204],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.09, 3.14],
    "c": "#d8f2ff"
  }, {
    "p": [96, -1, -194],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.96, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [102, -1, -138],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.96, 0],
    "c": "#d8f2ff"
  }, {
    "p": [194, -1, -268],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0],
    "c": "#d8f2ff"
  }, {
    "p": [195, -1, -353],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0],
    "c": "#d8f2ff"
  }, {
    "p": [96, -1, -352],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.52, 3.14],
    "c": "#d8f2ff"
  }, {
    "p": [198, -1, -390],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.52, 3.14],
    "c": "#d8f2ff"
  }, {
    "p": [100, 0, -370],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [100, 12, -370],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [97, -1, -380],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.52, 3.14],
    "c": "#d8f2ff"
  }, {
    "p": [142, -1, -422],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.04, 0],
    "c": "#d8f2ff"
  }, {
    "p": [212, -1, -422],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.04, 0],
    "c": "#d8f2ff"
  }, {
    "p": [218, 35, -427],
    "s": [7, 3, 7],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [134, 35, -427],
    "s": [7, 3, 7],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [274, 35, -427],
    "s": [7, 3, 7],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [152, -1, -354],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.05, 0],
    "c": "#d8f2ff"
  }, {
    "p": [194, 0, -308],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [193, -1, -331],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.86, 0],
    "c": "#d8f2ff"
  }, {
    "p": [194, 7, -308],
    "s": [6, 2, 6],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [220, -1, -114],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.87, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [4, 51, -82],
    "s": [3, 3, 3],
    "c": 9854020
  }, {
    "p": [4, 52, -60],
    "s": [3, 2, 3],
    "c": 9854020
  }, {
    "p": [4, 27, -60],
    "s": [3, 3, 3],
    "l": 1,
    "c": 9854020
  }, {
    "p": [216, 0, 91],
    "s": [20, 21, 36],
    "c": 11172712,
    "e": 1447446
  }, {
    "p": [216, 21, 91],
    "s": [1, 4, 40],
    "c": "#9b9a9a"
  }, {
    "p": [222, 20, 91],
    "s": [12, 1, 37],
    "l": 1,
    "r": [0, 0, -0.2],
    "c": "#9b9a9a"
  }, {
    "p": [210, 20, 91],
    "s": [12, 1, 37],
    "l": 1,
    "r": [0, 0, 0.2],
    "c": "#9b9a9a"
  }, {
    "p": [200, 0, 100],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [200, 12, 100],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [222, 21, 91],
    "s": [13, 2, 38],
    "l": 1,
    "r": [0, 0, -0.2],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [210, 21, 91],
    "s": [13, 2, 38],
    "l": 1,
    "r": [0, 0, 0.2],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [201, -1, 90],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.78, 0],
    "c": "#d8f2ff"
  }, {
    "p": [221, -1, 70],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.78, 0],
    "c": "#d8f2ff"
  }, {
    "p": [229, -1, 91],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.61, 0],
    "c": "#d8f2ff"
  }, {
    "p": [181, 0, 167],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [181, 12, 167],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [245, -1, 147],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.4, 0],
    "c": "#d8f2ff"
  }, {
    "p": [248, -1, 170],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.88, 0],
    "c": "#d8f2ff"
  }, {
    "p": [268, -1, 96],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0],
    "c": "#d8f2ff"
  }, {
    "p": [214, -1, 34],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.71, 0],
    "c": "#d8f2ff"
  }, {
    "p": [254, -1, 32],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.8, 0],
    "c": "#d8f2ff"
  }, {
    "p": [316, -1, 48],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.45, 0],
    "c": "#d8f2ff"
  }, {
    "p": [318, -1, 0],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.03, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [4, 27, -82],
    "s": [3, 4, 3],
    "l": 1,
    "c": 9854020
  }, {
    "p": [156, 0, 116],
    "s": [17, 2, 34],
    "c": 10197658
  }, {
    "p": [153, 0, 133],
    "s": [5, 33, 5],
    "c": 10197658
  }, {
    "p": [153, 0, 99],
    "s": [5, 33, 5],
    "c": 10197658
  }, {
    "p": [155, 33, 116],
    "s": [5, 3, 39],
    "c": 10197658,
    "bo": 1
  }, {
    "p": [152, 36, 116],
    "s": [13, 2, 40],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [74, 0, 158],
    "s": [155, 33, 50],
    "c": 11172712,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [157, -1, 135],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.43, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [158, -1, 96],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.43, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [133, 4, 127],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [184, -1, 158],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.88, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [-28, -1, -94],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [-95, -1, -190],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.71, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [-8, -1, -191],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.8, 0],
    "c": "#d8f2ff"
  }, {
    "p": [28, -1, -156],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.68, 0],
    "c": "#d8f2ff"
  }, {
    "p": [135, -1, -164],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.33, 0],
    "c": "#d8f2ff"
  }, {
    "p": [92, -1, -249],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.2, 3.14],
    "c": "#d8f2ff"
  }, {
    "p": [320, -1, -115],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.13, -1.48, -3.13],
    "c": "#d8f2ff"
  }, {
    "p": [253, -2, -170],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.96, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [272, -2, -149],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.61, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [245, -1, -176],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.13, -1.4, -3.13],
    "c": "#d8f2ff"
  }, {
    "p": [74, -1, -343],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.78, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [2, -1, -343],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.26, 0],
    "c": "#d8f2ff"
  }, {
    "p": [248, 0, -172],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [248, 7, -172],
    "s": [6, 2, 6],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [48, 4, 105],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [327, -1, -204],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#d8f2ff"
  }, {
    "p": [394, -1, -204],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#d8f2ff"
  }, {
    "p": [393, -1, -116],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -1.05, 3.14],
    "c": "#d8f2ff"
  }, {
    "p": [120, 0, -103],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [120, 7, -103],
    "s": [6, 2, 6],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [363, -1, -204],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#d8f2ff"
  }, {
    "p": [356, 0, -203],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [356, 7, -203],
    "s": [6, 2, 6],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [351, -1, -116],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.7, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [145, -1, 26],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.12, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [158, -1, -167],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.7, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [394, -1, -164],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -0.78, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [354, 0, -159],
    "s": [8, 8, 8],
    "pe": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [354, 8, -159],
    "s": [6, 7, 6],
    "pe": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [354, 15, -159],
    "s": [4, 4, 4],
    "pe": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [351, 10, -159],
    "s": [1, 1, 1],
    "l": 1,
    "c": "#474747",
    "t": 5
  }, {
    "p": [351, 13, -159],
    "s": [1, 1, 1],
    "l": 1,
    "c": "#474747",
    "t": 5
  }, {
    "p": [351, 16, -159],
    "s": [2, 1, 1],
    "l": 1,
    "c": "#ce7e3c",
    "t": 5
  }, {
    "p": [352, 17, -160],
    "s": [1, 1, 1],
    "l": 1,
    "c": "#474747",
    "t": 5
  }, {
    "p": [352, 17, -158],
    "s": [1, 1, 1],
    "l": 1,
    "c": "#474747",
    "t": 5
  }, {
    "p": [354, 13, -153],
    "s": [1, 1, 6],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#563f2c",
    "t": 5
  }, {
    "p": [354, 13, -165],
    "s": [1, 1, 6],
    "l": 1,
    "r": [0.44, 0, 0],
    "c": "#563f2c",
    "t": 5
  }, {
    "p": [354, 19, -159],
    "s": [6, 1, 6],
    "l": 1,
    "c": "#292929",
    "t": 5
  }, {
    "p": [354, 20, -159],
    "s": [4, 3, 4],
    "l": 1,
    "c": "#292929",
    "t": 5
  }, {
    "p": [349, -1, -163],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.48, 0],
    "c": "#d8f2ff"
  }, {
    "p": [350, -1, -154],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.61, 0],
    "c": "#d8f2ff"
  }, {
    "p": [360, -1, -160],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.22, 0],
    "c": "#d8f2ff"
  }, {
    "p": [6, 0, -347],
    "s": [5, 48, 7],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [211, 2, -68],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [211, 9, -68],
    "s": [6, 2, 6],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [6, 42, -343],
    "s": [1, 1, 3],
    "c": "#727272",
    "t": 5
  }, {
    "p": [6, 41, -340],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [6, 40, -340],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [-502, -26, -94],
    "s": [746, 26, 1221],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [14, 0, 67],
    "s": [34, 2, 18],
    "c": 10197658
  }, {
    "p": [-47, 4, 64],
    "s": [31, 1, 2],
    "c": "#453d2f",
    "t": 5
  }, {
    "p": [-47, 6, 68],
    "s": [31, 2, 1],
    "c": "#453d2f",
    "t": 5
  }, {
    "p": [-47, 9, 68],
    "s": [31, 2, 1],
    "c": "#453d2f",
    "t": 5
  }, {
    "p": [-34, 3, 66],
    "s": [1, 1, 7],
    "c": "#474747",
    "t": 5
  }, {
    "p": [-60, 3, 66],
    "s": [1, 1, 7],
    "c": "#474747",
    "t": 5
  }, {
    "p": [-60, 4, 69],
    "s": [1, 8, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [-34, 4, 69],
    "s": [1, 8, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [-34, 0, 68],
    "s": [1, 3, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [-34, 0, 64],
    "s": [1, 3, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [-60, 0, 64],
    "s": [1, 3, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [-60, 0, 68],
    "s": [1, 3, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [89, 4, 67],
    "s": [31, 1, 2],
    "c": "#453d2f",
    "t": 5
  }, {
    "p": [89, 4, 64],
    "s": [31, 1, 2],
    "c": "#453d2f",
    "t": 5
  }, {
    "p": [89, 6, 68],
    "s": [31, 2, 1],
    "c": "#453d2f",
    "t": 5
  }, {
    "p": [89, 9, 68],
    "s": [31, 2, 1],
    "c": "#453d2f",
    "t": 5
  }, {
    "p": [102, 3, 66],
    "s": [1, 1, 7],
    "c": "#474747",
    "t": 5
  }, {
    "p": [76, 3, 66],
    "s": [1, 1, 7],
    "c": "#474747",
    "t": 5
  }, {
    "p": [76, 4, 69],
    "s": [1, 8, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [102, 4, 69],
    "s": [1, 8, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [102, 0, 68],
    "s": [1, 3, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [102, 0, 64],
    "s": [1, 3, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [76, 0, 64],
    "s": [1, 3, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [76, 0, 68],
    "s": [1, 3, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [288, 4, -62],
    "s": [31, 1, 2],
    "c": "#453d2f",
    "t": 5
  }, {
    "p": [288, 4, -65],
    "s": [31, 1, 2],
    "c": "#453d2f",
    "t": 5
  }, {
    "p": [288, 6, -61],
    "s": [31, 2, 1],
    "c": "#453d2f",
    "t": 5
  }, {
    "p": [288, 9, -61],
    "s": [31, 2, 1],
    "c": "#453d2f",
    "t": 5
  }, {
    "p": [301, 3, -63],
    "s": [1, 1, 7],
    "c": "#474747",
    "t": 5
  }, {
    "p": [275, 3, -63],
    "s": [1, 1, 7],
    "c": "#474747",
    "t": 5
  }, {
    "p": [275, 4, -60],
    "s": [1, 8, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [301, 4, -60],
    "s": [1, 8, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [301, 0, -61],
    "s": [1, 3, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [301, 0, -65],
    "s": [1, 3, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [275, 0, -65],
    "s": [1, 3, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [275, 0, -61],
    "s": [1, 3, 1],
    "c": "#474747",
    "t": 5
  }, {
    "p": [213, 0, -201],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [213, 12, -201],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [223, -2, -203],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.96, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [98, 0, -139],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [98, 7, -139],
    "s": [6, 2, 6],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [146, 0, -423],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [146, 7, -423],
    "s": [6, 2, 6],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [135, -1, -355],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.79, 0],
    "c": "#d8f2ff"
  }, {
    "p": [143, 12, -350],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [149, 23, -242],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [149, 22, -242],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [72, 50, -52],
    "s": [1, 1, 3],
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [72, 49, -55],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [72, 48, -55],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [222, 46, 115],
    "s": [1, 1, 3],
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [222, 45, 118],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [222, 44, 118],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [322, 46, -1],
    "s": [1, 1, 3],
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [322, 45, 2],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [322, 44, 2],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [115, 34, 70],
    "s": [1, 1, 3],
    "c": "#727272",
    "t": 5
  }, {
    "p": [115, 33, 67],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [115, 32, 67],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [251, 30, -78],
    "s": [1, 1, 3],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [251, 29, -81],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [251, 28, -81],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [151, 40, -353],
    "s": [1, 1, 3],
    "c": "#727272",
    "t": 5
  }, {
    "p": [151, 39, -356],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [151, 38, -356],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [267, -1, -423],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.52, 3.14],
    "c": "#d8f2ff"
  }, {
    "p": [268, -1, -388],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#d8f2ff"
  }, {
    "p": [304, -1, -64],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, 0.88, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [-95, -1, -162],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0],
    "c": "#d8f2ff"
  }, {
    "p": [145, -48, -580],
    "s": [215, 142, 132],
    "l": 1,
    "c": "#aa7b68",
    "e": "#161616"
  }, {
    "p": [143, 63, -321],
    "s": [1, 1, 262],
    "l": 1,
    "c": 9539985,
    "t": 5
  }, {
    "p": [163, 63, -483],
    "s": [1, 1, 72],
    "l": 1,
    "r": [0, -0.61, 0],
    "c": 9539985,
    "t": 5
  }, {
    "p": [183, 63, -482],
    "s": [1, 1, 76],
    "l": 1,
    "r": [0, -0.61, 0],
    "c": 9539985,
    "t": 5
  }, {
    "p": [143, 0, -350],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [68, 0, -313],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [68, 12, -313],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [425, 76, -334],
    "s": [404, 3, 73],
    "l": 1,
    "r": [-0.44, 0, 0],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [425, 77, -259],
    "s": [404, 3, 73],
    "l": 1,
    "r": [0.43, 0, 0],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [429, 110, -282],
    "s": [322, 3, 29],
    "l": 1,
    "r": [0.43, 0, 0],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [429, 110, -311],
    "s": [322, 3, 29],
    "l": 1,
    "r": [-0.44, 0, 0],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [7, 23, -410],
    "s": [175, 3, 132],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [7, 26, -410],
    "s": [175, 2, 132],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [78, 31, -352],
    "s": [32, 17, 15],
    "c": 9854020,
    "e": "#0e0e0e"
  }, {
    "p": [-52, 31, -410],
    "s": [56, 17, 131],
    "c": 9854020,
    "e": "#0e0e0e"
  }, {
    "p": [78, 31, -469],
    "s": [32, 17, 13],
    "c": 9854020,
    "e": "#0e0e0e"
  }, {
    "p": [93, 31, -383],
    "s": [2, 17, 9],
    "c": "#965c44",
    "e": "#0e0e0e"
  }, {
    "p": [93, 42, -369],
    "s": [2, 6, 19],
    "c": "#965c44",
    "e": "#0e0e0e"
  }, {
    "p": [93, 42, -397],
    "s": [2, 6, 19],
    "c": "#965c44",
    "e": "#0e0e0e"
  }, {
    "p": [93, 31, -425],
    "s": [2, 17, 37],
    "c": "#965c44",
    "e": "#0e0e0e"
  }, {
    "p": [93, 42, -453],
    "s": [2, 6, 19],
    "c": "#965c44",
    "e": "#0e0e0e"
  }, {
    "p": [6, 31, -346],
    "s": [20, 17, 3],
    "c": "#965c44",
    "e": "#0e0e0e"
  }, {
    "p": [39, 31, -346],
    "s": [6, 17, 3],
    "c": "#965c44",
    "e": "#0e0e0e"
  }, {
    "p": [52, 43, -346],
    "s": [20, 5, 3],
    "c": "#965c44",
    "e": "#0e0e0e"
  }, {
    "p": [26, 43, -346],
    "s": [20, 5, 3],
    "c": "#965c44",
    "e": "#0e0e0e"
  }, {
    "p": [-14, 43, -346],
    "s": [20, 5, 3],
    "c": "#965c44",
    "e": "#0e0e0e"
  }, {
    "p": [6, 31, -474],
    "s": [20, 17, 3],
    "c": "#965c44",
    "e": "#0e0e0e"
  }, {
    "p": [39, 31, -474],
    "s": [6, 17, 3],
    "c": "#965c44",
    "e": "#0e0e0e"
  }, {
    "p": [93, 36, -412],
    "s": [1, 1, 107],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [17, 36, -346],
    "s": [90, 1, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [93, 30, -369],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [93, 30, -397],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [93, 30, -453],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [52, 30, -346],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [26, 30, -346],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-14, 30, -346],
    "s": [1, 14, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [8, 31, -401],
    "s": [169, 13, 109],
    "c": "#475e72",
    "o": 0.7000000000000001,
    "t": 5
  }, {
    "p": [92, 0, -427],
    "s": [6, 48, 7],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [98, -1, -420],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.22, 0],
    "c": "#d8f2ff"
  }, {
    "p": [160, 40, -162],
    "s": [5, 1, 3],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [160, 39, -162],
    "s": [4, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [157, 41, -162],
    "s": [5, 1, 1],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [36, 59, -138],
    "s": [1, 1, 3],
    "c": "#727272",
    "t": 5,
    "bo": 1
  }, {
    "p": [36, 58, -140],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#727272",
    "t": 5
  }, {
    "p": [36, 57, -140],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [-13, 66, -34],
    "s": [199, 3, 37],
    "l": 1,
    "r": [-0.79, 0, 0],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-13, 67, -8],
    "s": [199, 3, 41],
    "l": 1,
    "r": [0.78, 0, 0],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-100, 34, -156],
    "s": [7, 2, 7],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-100, 34, -112],
    "s": [7, 2, 7],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-169, 58, -245],
    "s": [115, 2, 101],
    "c": "#9b9a9a"
  }, {
    "p": [-169, 28, -245],
    "s": [115, 2, 101],
    "c": "#9b9a9a"
  }, {
    "p": [-169, 30, -245],
    "s": [115, 2, 101],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-169, 60, -245],
    "s": [116, 2, 102],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-224, -2, -197],
    "s": [4, 61, 4],
    "c": 10197658
  }, {
    "p": [-114, 0, -197],
    "s": [4, 58, 4],
    "c": 10197658
  }, {
    "p": [-173, 5, -245],
    "s": [4, 54, 100],
    "c": 10197658
  }, {
    "p": [-224, 2, -293],
    "s": [4, 57, 4],
    "c": 10197658
  }, {
    "p": [-114, -2, -293],
    "s": [4, 61, 4],
    "c": "#9b9a9a"
  }, {
    "p": [-224, -2, -197],
    "s": [5, 7, 5],
    "c": 10197658
  }, {
    "p": [-114, -1, -197],
    "s": [5, 6, 5],
    "c": 10197658
  }, {
    "p": [-173, -1, -245],
    "s": [5, 6, 101],
    "c": 10197658
  }, {
    "p": [-114, -2, -293],
    "s": [5, 7, 5],
    "c": 10197658
  }, {
    "p": [-224, -2, -293],
    "s": [5, 7, 5],
    "c": 10197658
  }, {
    "p": [-169, -1, -245],
    "s": [113, 37, 99],
    "c": 9854020
  }, {
    "p": [-117, 36, -245],
    "s": [9, 15, 99],
    "c": 9854020
  }, {
    "p": [-169, 51, -245],
    "s": [113, 7, 99],
    "c": 9854020
  }, {
    "p": [-173, 36, -245],
    "s": [22, 15, 99],
    "c": 9854020
  }, {
    "p": [-221, 36, -288],
    "s": [9, 15, 13],
    "c": 9854020
  }, {
    "p": [-221, 36, -245],
    "s": [9, 15, 11],
    "c": 9854020
  }, {
    "p": [-221, 36, -202],
    "s": [9, 15, 13],
    "c": 9854020
  }, {
    "p": [-169, 43, -293],
    "s": [98, 1, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-169, 43, -197],
    "s": [98, 1, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-206, 36, -293],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-194, 36, -293],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-149, 36, -293],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-135, 36, -293],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-135, 36, -197],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-149, 36, -197],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-194, 36, -197],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-206, 36, -197],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-224, 36, -229],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-224, 36, -272],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-224, 43, -246],
    "s": [1, 1, 78],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-171, 36, -245],
    "s": [105, 15, 95],
    "c": "#475e72",
    "o": 0.7000000000000001,
    "t": 5
  }, {
    "p": [-224, 36, -261],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [-224, 36, -218],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [208, 58, 223],
    "s": [115, 2, 101],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [208, 28, 223],
    "s": [115, 2, 101],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [208, 30, 223],
    "s": [115, 2, 101],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [208, 60, 223],
    "s": [116, 2, 102],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [153, -2, 271],
    "s": [4, 61, 4],
    "c": 10197658
  }, {
    "p": [263, 0, 271],
    "s": [4, 58, 4],
    "c": 10197658
  }, {
    "p": [204, 5, 177],
    "s": [4, 54, 8],
    "c": 10197658
  }, {
    "p": [153, 2, 175],
    "s": [4, 57, 4],
    "c": 10197658
  }, {
    "p": [263, -2, 175],
    "s": [4, 61, 4],
    "c": "#9b9a9a"
  }, {
    "p": [153, -2, 271],
    "s": [5, 7, 5],
    "c": 10197658
  }, {
    "p": [263, -1, 271],
    "s": [5, 6, 5],
    "c": 10197658
  }, {
    "p": [204, -1, 223],
    "s": [5, 6, 101],
    "c": 10197658
  }, {
    "p": [263, -2, 175],
    "s": [5, 7, 5],
    "c": 10197658
  }, {
    "p": [153, -2, 175],
    "s": [5, 7, 5],
    "c": 10197658
  }, {
    "p": [208, -1, 223],
    "s": [113, 34, 99],
    "c": 9854020,
    "bo": 1
  }, {
    "p": [260, 33, 223],
    "s": [9, 18, 99],
    "c": "#965c44"
  }, {
    "p": [208, 51, 223],
    "s": [113, 7, 99],
    "c": 9854020
  }, {
    "p": [204, 36, 176],
    "s": [22, 15, 5],
    "c": 9854020
  }, {
    "p": [156, 36, 180],
    "s": [9, 15, 13],
    "c": 9854020
  }, {
    "p": [156, 36, 223],
    "s": [9, 15, 11],
    "c": 9854020
  }, {
    "p": [156, 36, 266],
    "s": [9, 15, 13],
    "c": 9854020
  }, {
    "p": [208, 43, 175],
    "s": [98, 1, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [208, 43, 271],
    "s": [98, 1, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [171, 36, 175],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [183, 36, 175],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [228, 36, 175],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [242, 36, 175],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [242, 36, 271],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [228, 36, 271],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [183, 36, 271],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [171, 36, 271],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [153, 36, 239],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [153, 36, 196],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [153, 43, 222],
    "s": [1, 1, 78],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [206, 36, 223],
    "s": [105, 15, 95],
    "c": "#475e72",
    "o": 0.7000000000000001,
    "t": 5
  }, {
    "p": [153, 36, 207],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [153, 36, 250],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#4f4f4f"
  }, {
    "p": [200, -4, -410],
    "s": [40, 54, 37],
    "i": 32,
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [151, 11, -363],
    "s": [30, 33, 36],
    "i": 32,
    "l": 1,
    "r": [0.26, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [6, 12, -330],
    "s": [29, 34, 39],
    "i": 32,
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [111, 15, -299],
    "s": [28, 35, 36],
    "i": 32,
    "l": 1,
    "r": [0, 0, 0.43],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [169, 19, -162],
    "s": [28, 25, 36],
    "i": 32,
    "l": 1,
    "r": [0, 0, 0.43],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [149, 5, -236],
    "s": [36, 20, 34],
    "i": 32,
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [309, 13, -143],
    "s": [28, 35, 36],
    "i": 32,
    "l": 1,
    "r": [0, 0, 0.43],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [288, 5, -65],
    "s": [31, 1, 2],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [288, 5, -62],
    "s": [31, 1, 2],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [288, 11, -61],
    "s": [31, 1, 1],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [251, 7, -86],
    "s": [30, 25, 36],
    "i": 32,
    "l": 1,
    "r": [0.26, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [172, 4, -87],
    "s": [43, 46, 38],
    "i": 32,
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [72, 9, -69],
    "s": [43, 46, 38],
    "i": 32,
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [222, 6, 132],
    "s": [43, 46, 38],
    "i": 32,
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [322, 13, 13],
    "s": [43, 38, 38],
    "i": 32,
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [-13, 3, -175],
    "s": [43, 46, 38],
    "i": 32,
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [28, 4, 30],
    "s": [43, 46, 38],
    "i": 32,
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [115, 5, 57],
    "s": [43, 32, 38],
    "i": 32,
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [36, 31, -152],
    "s": [43, 32, 38],
    "i": 32,
    "l": 1,
    "r": [0.44, 0, 0],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [-82, 17, -136],
    "s": [33, 32, 36],
    "i": 32,
    "l": 1,
    "r": [0, 0, 0.43],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [105, 22, -21],
    "s": [28, 25, 36],
    "i": 32,
    "l": 1,
    "r": [0, 0, 0.43],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [-81, 16, 42],
    "s": [31, 35, 36],
    "i": 32,
    "l": 1,
    "r": [0, 0, 0.43],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [170, 15, 76],
    "s": [31, 35, 36],
    "i": 32,
    "l": 1,
    "r": [0, 0, 0.43],
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [89, 5, 64],
    "s": [31, 1, 2],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [89, 5, 67],
    "s": [31, 1, 2],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [89, 11, 68],
    "s": [31, 1, 1],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-47, 5, 64],
    "s": [31, 1, 2],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-47, 5, 67],
    "s": [31, 1, 2],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-47, 11, 68],
    "s": [31, 1, 1],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-380, -3, 105],
    "s": [251, 96, 122],
    "l": 1,
    "c": 11172712,
    "e": 1447446
  }, {
    "p": [-227, -3, -96],
    "s": [203, 63, 61],
    "l": 1,
    "c": "#965c44"
  }, {
    "p": [-135, 46, -81],
    "s": [8, 43, 43],
    "l": 1,
    "r": [-0.8, 0, 0],
    "c": 9854020
  }, {
    "p": [-323, 45, -81],
    "s": [8, 43, 43],
    "l": 1,
    "r": [-0.8, 0, 0],
    "c": 9854020
  }, {
    "p": [-227, 60, -96],
    "s": [204, 3, 62],
    "l": 1,
    "c": 10197658
  }, {
    "p": [-227, 63, -96],
    "s": [205, 2, 63],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-229, 77, -110],
    "s": [199, 3, 37],
    "l": 1,
    "r": [-0.79, 0, 0],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-229, 78, -84],
    "s": [199, 3, 41],
    "l": 1,
    "r": [0.78, 0, 0],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-209, -3, 88],
    "s": [203, 62, 61],
    "l": 1,
    "c": 9854020
  }, {
    "p": [-117, 45, 103],
    "s": [8, 43, 43],
    "l": 1,
    "r": [-0.8, 0, 0],
    "c": 9854020
  }, {
    "p": [-305, 44, 103],
    "s": [8, 43, 43],
    "l": 1,
    "r": [-0.8, 0, 0],
    "c": 9854020
  }, {
    "p": [-209, 59, 88],
    "s": [204, 3, 62],
    "l": 1,
    "c": 10197658
  }, {
    "p": [-209, 62, 88],
    "s": [205, 2, 63],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-211, 76, 74],
    "s": [199, 3, 37],
    "l": 1,
    "r": [-0.79, 0, 0],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-211, 77, 100],
    "s": [199, 3, 41],
    "l": 1,
    "r": [0.78, 0, 0],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-204, -9, -353],
    "s": [203, 65, 61],
    "l": 1,
    "c": 9854020
  }, {
    "p": [-112, 42, -338],
    "s": [8, 43, 43],
    "l": 1,
    "r": [-0.8, 0, 0],
    "c": 9854020
  }, {
    "p": [-300, 41, -338],
    "s": [8, 43, 43],
    "l": 1,
    "r": [-0.8, 0, 0],
    "c": 9854020
  }, {
    "p": [-204, 56, -353],
    "s": [204, 3, 62],
    "l": 1,
    "c": 10197658
  }, {
    "p": [-204, 59, -353],
    "s": [205, 2, 63],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-206, 73, -367],
    "s": [199, 3, 37],
    "l": 1,
    "r": [-0.79, 0, 0],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-206, 74, -341],
    "s": [199, 3, 41],
    "l": 1,
    "r": [0.78, 0, 0],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-387, -3, -231],
    "s": [251, 96, 122],
    "l": 1,
    "c": 11172712,
    "e": 1447446
  }, {
    "p": [-387, 93, -231],
    "s": [255, 4, 125],
    "l": 1,
    "c": "#bababa"
  }, {
    "p": [229, 97, -296],
    "s": [12, 3, 12],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [204, 36, 270],
    "s": [22, 15, 5],
    "c": 9854020
  }, {
    "p": [208, 33, 176],
    "s": [95, 3, 5],
    "c": 9854020
  }, {
    "p": [208, 33, 270],
    "s": [108, 3, 5],
    "c": 9854020
  }, {
    "p": [156, 33, 223],
    "s": [9, 3, 99],
    "c": 9854020
  }, {
    "p": [204, 5, 270],
    "s": [4, 54, 6],
    "c": 10197658
  }, {
    "p": [335, -28, 18],
    "s": [1734, 3, 2577],
    "l": 1,
    "c": "#4a433a",
    "t": 5,
    "ts": 0.8
  }, {
    "p": [281, 0, -126],
    "s": [49, 0, 70],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [145, 0, -263],
    "s": [54, 0, 64],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [235, 0, -203],
    "s": [98, 0, 29],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [122, 0, -105],
    "s": [41, 0, 23],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [81, 0, -53],
    "s": [41, 0, 32],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [84, 0, 68],
    "s": [48, 0, 35],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [213, 0, 92],
    "s": [44, 0, 55],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [26, 0, 13],
    "s": [47, 0, 26],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-40, 0, 7],
    "s": [35, 0, 32],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-30, 0, -87],
    "s": [41, 0, 59],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [150, 0, -64],
    "s": [41, 0, 40],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [147, 0, -352],
    "s": [35, 0, 41],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [77, 0, -301],
    "s": [49, 0, 46],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [200, 0, -373],
    "s": [49, 0, 63],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [149, 0, -182],
    "s": [40, 0, 46],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-96, 0, -181],
    "s": [25, 0, 63],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [246, 0, -66],
    "s": [30, 0, 37],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [82, 0, -198],
    "s": [50, 0, 38],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [194, -1, -224],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.78, 0],
    "c": "#d8f2ff"
  }, {
    "p": [141, 0, -430],
    "s": [31, 0, 39],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [204, 0, -125],
    "s": [49, 0, 56],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [327, -30, 222],
    "s": [5, 36, 143],
    "c": "#b5b5b5"
  }, {
    "p": [305, -29, 147],
    "s": [49, 35, 7],
    "c": "#b5b5b5"
  }, {
    "p": [305, 6, 147],
    "s": [49, 2, 7],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [327, 6, 290],
    "s": [5, 2, 279],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [300, -29, 247],
    "s": [50, 29, 194],
    "c": "#818d93",
    "t": 5
  }, {
    "p": [217, -48, 353],
    "s": [215, 142, 132],
    "l": 1,
    "c": "#965c44"
  }, {
    "p": [327, -30, 365],
    "s": [5, 36, 143],
    "l": 1,
    "c": "#b5b5b5"
  }, {
    "p": [268, 0, 170],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.4, 0],
    "c": "#d8f2ff"
  }, {
    "p": [320, 0, 172],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.35, 3.14],
    "c": "#d8f2ff"
  }, {
    "p": [271, 0, 152],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.22, 0],
    "c": "#d8f2ff"
  }, {
    "p": [317, 0, 159],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [317, 12, 159],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [217, 94, 353],
    "s": [217, 3, 136],
    "l": 1,
    "c": "#5b5b5b"
  }, {
    "p": [217, 97, 353],
    "s": [219, 2, 139],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [217, 44, 353],
    "s": [217, 3, 136],
    "l": 1,
    "c": "#5b5b5b"
  }, {
    "p": [217, 47, 353],
    "s": [219, 2, 139],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [294, -1, 235],
    "s": [61, 29, 109],
    "c": 9854020,
    "bo": 1
  }, {
    "p": [294, 28, 235],
    "s": [63, 2, 111],
    "c": "#9b9a9a"
  }, {
    "p": [-333, -3, -47],
    "s": [56, 157, 37],
    "l": 1,
    "c": "#965c44"
  }, {
    "p": [-22, 0, -144],
    "s": [36, 0, 39],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-97, 0, -87],
    "s": [25, 0, 37],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [93, 0, -253],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [93, 7, -253],
    "s": [6, 2, 6],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [270, 48, -60],
    "s": [95, 1, 28],
    "i": 30,
    "r": [1.57, 0, -3.14],
    "st": "A-13",
    "sc": "#6b493b",
    "bv": 1,
    "sf": 120
  }, {
    "p": [222, 48, -311],
    "s": [95, 1, 28],
    "i": 30,
    "r": [1.57, 0, 1.57],
    "st": "C-12",
    "sc": "#936e5f",
    "bv": 1,
    "sf": 120
  }, {
    "p": [274, 49, -224],
    "s": [95, 1, 28],
    "i": 30,
    "r": [1.57, 0, 0],
    "st": "C-12",
    "sc": "#936e5f",
    "bv": 1,
    "sf": 120
  }, {
    "p": [101, 56, 71],
    "s": [95, 1, 28],
    "i": 30,
    "r": [1.57, 0, -3.14],
    "st": "A-13",
    "sc": "#896e62",
    "bv": 1,
    "sf": 120
  }, {
    "p": [152, 57, 70],
    "s": [97, 1, 30],
    "i": 30,
    "r": [1.57, 0, -1.57],
    "st": "A-13",
    "sc": "#b18876",
    "bv": 1,
    "sf": 120
  }, {
    "p": [-48, -1, -192],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0],
    "c": "#d8f2ff"
  }, {
    "p": [-40, 0, -338],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-39, -1, -332],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.78, -3.14],
    "c": "#d8f2ff"
  }, {
    "p": [-40, 7, -338],
    "s": [6, 2, 6],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [268, 0, -417],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [268, 7, -417],
    "s": [6, 2, 6],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [50, 0, -144],
    "s": [37, 0, 30],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [-100, 0, 36],
    "s": [7, 34, 7],
    "c": "#ababab",
    "bo": 1
  }, {
    "p": [-100, 34, 36],
    "s": [7, 2, 7],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [14, 31, 86],
    "s": [6, 2, 7],
    "l": 1,
    "c": "#777777",
    "t": 5
  }, {
    "p": [14, 30, 86],
    "s": [3, 2, 3],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [14, 14, 86],
    "s": [43, 18, 38],
    "i": 32,
    "l": 1,
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [56, 31, 115],
    "s": [6, 2, 7],
    "l": 1,
    "c": "#777777",
    "t": 5
  }, {
    "p": [56, 30, 115],
    "s": [3, 2, 3],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [56, 14, 115],
    "s": [43, 18, 38],
    "i": 32,
    "l": 1,
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [122, 31, 115],
    "s": [6, 2, 7],
    "l": 1,
    "c": "#777777",
    "t": 5
  }, {
    "p": [122, 30, 115],
    "s": [3, 2, 3],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [122, 14, 115],
    "s": [43, 18, 38],
    "i": 32,
    "l": 1,
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [192, 25, 146],
    "s": [10, 2, 2],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [188, 19, 146],
    "s": [2, 6, 2],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [192, 23, 146],
    "s": [4, 2, 2],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [241, 61, -239],
    "s": [15, 81, 12],
    "c": "#472213",
    "e": 1447446
  }, {
    "p": [241, 142, -239],
    "s": [18, 4, 15],
    "c": "#4f4f4f",
    "t": 5
  }, {
    "p": [-67, 26, -65],
    "s": [3, 1, 2],
    "l": 1,
    "r": [0, -0.61, 0],
    "c": 9854020
  }, {
    "p": [-83, 27, -83],
    "s": [5, 2, 3],
    "l": 1,
    "r": [0, 0.26, 0],
    "c": 9854020
  }, {
    "p": [-3, 25, -95],
    "s": [5, 2, 3],
    "l": 1,
    "r": [0, 0.7, 0],
    "c": 9854020
  }, {
    "p": [-16, 25, -95],
    "s": [2, 1, 3],
    "l": 1,
    "r": [0, 0.7, 0],
    "c": 9854020
  }, {
    "p": [-5, 26, -61],
    "s": [2, 1, 3],
    "l": 1,
    "r": [0, 0.7, 0],
    "c": 9854020
  }, {
    "p": [-21, 28, -87],
    "s": [3, 1, 4],
    "l": 1,
    "c": 9854020
  }, {
    "p": [356, 0, -160],
    "s": [64, 50, 90],
    "i": 14
  }, {
    "p": [213, 0, 92],
    "s": [78, 50, 76],
    "i": 14
  }, {
    "p": [145, 0, -376],
    "s": [76, 50, 68],
    "i": 14
  }, {
    "p": [-66, 0, -138],
    "s": [59, 50, 89],
    "i": 14
  }, {
    "p": [151, 0, -396],
    "s": [24, 36, 24],
    "i": 23,
    "tm": 0
  }, {
    "p": [249, 0, 95],
    "s": [24, 36, 24],
    "i": 23,
    "tm": "1"
  }, {
    "p": [50, 0, -410],
    "s": [88, 31, 131],
    "c": "#965c44",
    "e": "#0e0e0e",
    "bo": 1
  }, {
    "p": [-15, 26, -410],
    "s": [42, 5, 131],
    "c": "#965c44",
    "e": "#0e0e0e",
    "bo": 1
  }, {
    "p": [-15, 0, -395],
    "s": [42, 23, 46],
    "c": "#965c44",
    "e": "#0e0e0e",
    "bo": 1
  }, {
    "p": [-32, -1, -369],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0],
    "c": "#d8f2ff"
  }, {
    "p": [4, -1, -369],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0],
    "c": "#d8f2ff"
  }, {
    "p": [352, 0, -159],
    "s": [26, 0, 27],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [196, 59, -23],
    "s": [115, 2, 109],
    "c": "#9b9a9a",
    "bo": 1
  }, {
    "p": [196, 61, -23],
    "s": [116, 2, 110],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [174, 0, -23],
    "s": [69, 37, 107],
    "c": 9854020,
    "bo": 1
  }, {
    "p": [226, 0, 29],
    "s": [47, 37, 3],
    "c": 9854020,
    "bo": 1
  }, {
    "p": [248, 0, -40],
    "s": [9, 37, 73],
    "c": 9854020,
    "bo": 1
  }, {
    "p": [250, 33, 12],
    "s": [5, 4, 31],
    "c": 9854020,
    "bo": 1
  }, {
    "p": [226, 33, -75],
    "s": [35, 4, 3],
    "c": 9854020,
    "bo": 1
  }, {
    "p": [226, 0, 28],
    "s": [68, 0, 33],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [211, 0, -68],
    "s": [22, 0, 33],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [292, 0, 47],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [292, 12, 47],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [301, 0, 44],
    "s": [45, 0, 24],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [294, 30, 235],
    "s": [65, 2, 112],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [324, -30, 230],
    "s": [20, 58, 99],
    "v": 1,
    "c": "#000000",
    "e": 1447446,
    "bo": 1
  }, {
    "p": [-39, 0, -340],
    "s": [27, 0, 32],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [251, -11, -341],
    "s": [109, 39, 79],
    "c": 7485215,
    "e": 1447446,
    "bo": 1
  }, {
    "p": [21, 0, -339],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [21, 12, -339],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [191, 0, -216],
    "s": [12, 12, 12],
    "i": 1
  }, {
    "p": [191, 12, -216],
    "s": [12, 2, 12],
    "l": 1,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [190, -1, -304],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#d8f2ff"
  }, {
    "p": [273, -2, -203],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.61, 0],
    "c": "#d8f2ff"
  }, {
    "p": [291, 28, -201],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#777777",
    "t": 5
  }, {
    "p": [291, 27, -201],
    "s": [2, 1, 4],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [291, 11, -201],
    "s": [43, 18, 38],
    "i": 32,
    "l": 1,
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [192, 28, -288],
    "s": [5, 1, 3],
    "l": 1,
    "c": "#777777",
    "t": 5
  }, {
    "p": [192, 27, -288],
    "s": [4, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [192, 11, -288],
    "s": [43, 18, 38],
    "i": 32,
    "l": 1,
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [252, -2, -204],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#d8f2ff"
  }, {
    "p": [315, 0, -205],
    "s": [39, 0, 54],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [291, 0, -204],
    "s": [31, 2, 6],
    "c": 10197658
  }, {
    "p": [291, 0, -255],
    "s": [27, 2, 96],
    "c": 10197658
  }, {
    "p": [237, 0, -287],
    "s": [81, 2, 29],
    "c": 10197658
  }, {
    "p": [194, 0, -287],
    "s": [5, 2, 32],
    "c": 10197658
  }, {
    "p": [291, 27, -286],
    "s": [6, 2, 7],
    "l": 1,
    "c": "#777777",
    "t": 5
  }, {
    "p": [291, 26, -286],
    "s": [3, 2, 3],
    "l": 1,
    "c": "#000000",
    "e": "#e9edb8",
    "t": 5
  }, {
    "p": [291, 10, -286],
    "s": [43, 18, 38],
    "i": 32,
    "l": 1,
    "c": "#e8eda1",
    "o": 0.2
  }, {
    "p": [201, 0, -283],
    "s": [39, 0, 71],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [291, 29, -204],
    "s": [1, 1, 3],
    "l": 1,
    "c": "#777777",
    "t": 5
  }, {
    "p": [194, 29, -288],
    "s": [3, 1, 1],
    "l": 1,
    "c": "#777777",
    "t": 5
  }, {
    "p": [240, 0, 166],
    "s": [61, 0, 51],
    "i": 4,
    "l": 1,
    "en": 5,
    "c": "#818d93",
    "t": 5
  }, {
    "p": [226, -1, -24],
    "s": [35, 3, 105],
    "c": 10197658
  }, {
    "p": [250, -1, 12],
    "s": [13, 3, 34],
    "c": 10197658
  }, {
    "p": [260, -1, -1],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0],
    "c": "#d8f2ff"
  }, {
    "p": [226, -1, -78],
    "s": [39, 3, 3],
    "c": 10197658
  }, {
    "p": [207, -1, -80],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.97, 0],
    "c": "#d8f2ff"
  }, {
    "p": [-54, 55, 70],
    "s": [62, 0, 25],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -3.14],
    "sad": 1
  }, {
    "p": [-54, 41, 71],
    "s": [67, 28, 1],
    "l": 1,
    "c": "#433d31",
    "t": 5
  }, {
    "p": [-54, 40, 71],
    "s": [69, 2, 3],
    "l": 1,
    "c": "#433d31",
    "t": 5
  }, {
    "p": [221, 47, -266],
    "s": [47, 0, 19],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, -1.57],
    "sad": 1
  }, {
    "p": [222, 36, -266],
    "s": [1, 21, 49],
    "l": 1,
    "c": "#433d31",
    "t": 5
  }, {
    "p": [-125, 47, -102],
    "s": [42, 0, 20],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "sad": 1
  }]
}